var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8087 7.54628C21.7147 6.69921 22.9096 6.25 24.1232 6.25H35.8768C37.0904 6.25 38.2853 6.6992 39.1913 7.54628L44.6231 12.625H49.8864C53.9303 12.625 57.5 15.7293 57.5 19.9062V46.4687C57.5 50.6457 53.9303 53.75 49.8864 53.75H10.1136C6.06966 53.75 2.5 50.6457 2.5 46.4687V19.9062C2.5 15.7293 6.06966 12.625 10.1136 12.625H15.3769L20.8087 7.54628ZM24.1685 11.25L18.0711 16.9511C17.608 17.3841 16.9976 17.625 16.3636 17.625H10.1136C8.50924 17.625 7.5 18.802 7.5 19.9062V46.4687C7.5 47.573 8.50925 48.75 10.1136 48.75H49.8864C51.4908 48.75 52.5 47.573 52.5 46.4687V19.9062C52.5 18.802 51.4908 17.625 49.8864 17.625H43.6364C43.0024 17.625 42.392 17.3841 41.9289 16.9511L35.8315 11.25H24.1685ZM35.7764 11.1985C35.7766 11.1987 35.7762 11.1983 35.7764 11.1985V11.1985Z",
    fill: "#90A4AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 27.5C27.2386 27.5 25 29.7386 25 32.5C25 35.2614 27.2386 37.5 30 37.5C32.7614 37.5 35 35.2614 35 32.5C35 29.7386 32.7614 27.5 30 27.5ZM20 32.5C20 26.9772 24.4772 22.5 30 22.5C35.5228 22.5 40 26.9772 40 32.5C40 38.0228 35.5228 42.5 30 42.5C24.4772 42.5 20 38.0228 20 32.5Z",
    fill: "#90A4AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 25C46.25 26.3807 45.1307 27.5 43.75 27.5C42.3693 27.5 41.25 26.3807 41.25 25C41.25 23.6193 42.3693 22.5 43.75 22.5C45.1307 22.5 46.25 23.6193 46.25 25Z",
    fill: "#90A4AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.6f60d3aeb95a96007b1c7b204ec0c796.svg";
export { ForwardRef as ReactComponent };